<template>
  <div class="hvh-flex column space-between">
    <h2 class="hvh-h5 mb-4">Insurance Distribution</h2>
    <HvhChart :options="barChartInsuranceOptions" :visualization="barChartInsuranceData" height="350px" @item-clicked="emitValue" />
  </div>
</template>

<script>
import { getDemographics } from '../../../../libraries/cohorts';
import { customNumberFormat } from '../../../../libraries/common';
import HvhChart from '../../../charts/HvhChart.vue';
export default {
  components: { HvhChart },
  props: ['cohort', 'value'],
  data() {
    return {
      barChartInsuranceOptions: {
        grid: {
          left: '5%',
          right: '5%'
        },
        series: [
          {
            barMaxWidth: 30
          }
        ],
        tooltip: {
          formatter: (params) => {
            var count = this.barChartInsuranceData.data[params.dataIndex]['count']
            return `${params.name}<br>${params.marker}${customNumberFormat(count)}`;
          }
        },
        yAxis: {
          axisLabel: {
            formatter: '{value}%'
          },
          name: 'Percent of Total',
          nameGap: 45
        }
      }
    };
  },
  computed: {
    barChartInsuranceData() {
      const keys = getDemographics().insurances.head();

      const insuranceData = this.cohort.cohortStatistic.cohortInsuranceStatistics;
      const sum = insuranceData.sum(f => f.count);

      const insuranceObj = insuranceData.reduce((acc, f) => {
        const key = keys.includes(f.insurance) ? f.insurance : 'Other';
        acc[key] = acc[key] + f.count;
        return acc;
      }, keys.concat('Other').reduce((acc, key) => ({ ...acc, [key]: 0 }), {}));

      const data = Object.keys(insuranceObj)
        .map(key => ({
          insuranceName: key,
          cohortPercent: Math.round(insuranceObj[key] * 10000 / sum) / 100,
          count: insuranceObj[key],
          color: (this.value || []).any() && !(this.value || []).includes(key) && 'rgb(216,216,216)',
        }));


      return {
        visualization_type: 'barchart',
        name_field: 'insuranceName',
        value_field: 'cohortPercent',
        data
      };
    },
  },
  methods: {
    emitValue(event) {
      var value = (this.value?.length !== this.barChartInsuranceData.data.length && this.value) || [];
      var sortedValue = value
        .toggle(event.insuranceName)
        .sortBy(f => f);
      this.$emit('input', sortedValue);
    },
  },
}
</script>